<template>
  <div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="text-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <span class="title" v-html="item.title"></span>
      <van-image
        width="20"
        height="3"
        class="line-img"
        :src="require('@/assets/line.png')"
      />
      <span class="desc">{{ item.summary }}</span>
      <span class="time">{{ Number(item.create_time) | datetimeFormat }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      // this.$router.push({
      //   path: "/article/" + id,
      // });
      const detail = this.$router.resolve({ path: "/article/" + id });
      window.open(detail.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.text-content {
  display: inline-block;
  width: 538px;
  height: 237px;
  margin-top: 30px;
  margin-left: 43px;
  cursor: pointer;
  border: 1px solid #0047ff;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 460px;
    height: 55px;
    margin-top: 27px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .line-img {
    margin-top: 20px;
    margin-left: 40px;
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 460px;
    height: 55px;
    margin-top: 19px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .time {
    display: inline-block;
    margin-top: 20px;
    margin-left: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
  }
}
</style>
